<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc('aggregator', 1)}}
          <span
            class="icon-question"
            v-b-tooltip.hover.top="'Aggregators are the 3rd party applications who use cinematic to book tickets and/or Food & beverages on line'"
          ></span>
        </div>
        <div class="section-subTitle my-2">{{ $t('aggregator_dash_msg') }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-aggregator" class="btn-blue">{{ $t('add') }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>

        <button
          v-if = GridViewFlag
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          v-if = GridViewFlag
          class="btnj btn-listView"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Aggregators.length > 0"
        v-for="(item , key) in Aggregators"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.aggregator_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item @click="goToRoute('/cinema-manager/edit-aggregator',item)">
                  <span class="edit-pen mr-1"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/cinema-manager/view-aggregator',item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input
                  v-model="item.aggregator_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Aggregators.length == 0">
        <p>{{ $t('NoRecords') }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>{{ $tc('aggregator', 1) }}</th>
          <th class="text-right">
            <span class="pr-5">{{ $tc('active')}}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="Aggregators.length >0">
        <tr v-for="(item , key) in Aggregators" :key="key">
          <td>{{ $tc(item.aggregator_name, 1) }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <label class="ios-switch">
                <input
                  v-model="item.aggregator_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label>

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item @click="goToRoute('/cinema-manager/edit-aggregator',item)">
                  <span class="edit-pen mr-1"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/cinema-manager/view-aggregator',item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-if="Aggregators.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="Aggregators.length >0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>



<script>
import MasterService from "@/services/MasterService";
import Aggregators from "@/helper/formJSONMaster/Aggregators";

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Aggregators.Methods,
      Aggregators: [],
      customErrors: {
        message: ""
      }
    };
  },
  beforeMount() {
    this.getAggregatorsList();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getAggregatorsList();
      } else {
        this.currentPage = event;
        this.getAggregatorsList();
      }
    },
    goToRoute: function(path, item) {
      console.log("item :", item);
      const { aggregator_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: aggregator_id
        }
      });
    },
    getAggregatorsList: function() {
      this.Aggregators = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}`;
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Aggregators = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AggregatorsComponents/aggregators.vue